<template>
  <div class="com-box">
    <img class="head-title" src="https://img3.quanyou.com.cn/joyNew/group1/M00/1D/E0/rB8LrWU6EmuAKyqsAABI-Sb_lp8734.png" />
    <div class="card">
      <div class="item-box left">
        <div class="top">
          <img class="img" src="https://img3.quanyou.com.cn/joyNew/group1/M00/1D/D4/rB8LrWU53sCAFghEAABLiPE9RgA022.png" />
        </div>
        <div class="bottom">
          <!-- <span>c门店</span>
          <span class="line">|</span>
          <span>拉拉啊</span> -->
          当前为预览活动，暂无门店
        </div>
      </div>
      <div class="item-box">
        <img class="top" src="https://img3.quanyou.com.cn/joyNew/group1/M00/1D/D4/rB8LrmU54J2AdjPzAAFWeYazwI4624.png" />
        <div class="bottom">
          <span>当前为预览活动，暂无门店</span>
        </div>
      </div>
    </div>
    <img class="more" src="https://img3.quanyou.com.cn/joyNew/group1/M00/1D/DC/rB8LrWU59XOAZftfAAAXFy7F3-w390.png" />
  </div>
</template>

<script>
export default {
 
}
</script>

<style lang="stylus" scoped>
  .com-box {
    width: 100%;
    height: 286px; 
    background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1D/D2/rB8LrWU51f2AETLlAABfXlQyd28556.png');
    background-size: 100% 100%;
    margin-top: 20px;
    .head-title {
      width: 375px;
      height: 50px;
      margin-top: -18px;
    }
    .card {
      display: flex;
      padding: 0 14px;
      box-sizing: border-box;
      width: 344px;
      margin: auto;
      margin-top: 10px;
      .item-box {
        width: 153px;
        height: 175px;
        padding: 9px 12px;
        box-sizing: border-box;
        background: #FFF7ED;
        border: 1px solid #FD7A2B;
        border-radius: 9px;
        .top {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 129px;
          height: 109px;
          background: #FFFFFF;
          border-radius: 9px;
          .img {
            width: 74px;
            height: 74px;
          }
        }
      }
      .left {
        margin-right: 9px;
      }
      .bottom {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #EE591D;
        font-size: 13px;
        font-weight: bold;
        margin-top: 12px;
        .line {
          margin: 0 8px;
        }
      }
    }
    .more {
      display: block;
      width: 111px;
      height: 36px;
      margin: auto;
      margin-top: 7px;
    }
  }
</style>